export default __webpack_public_path__ + "static/media/payment_policy.ffc10399.pdf";